import { DragDropButton } from '@/components/gantt/dragDrop/DragDropButton';
import { ItemTypes } from '@/components/gantt/dragDrop/types';
import { itemTypeToColor } from '@/helpers/dailyHelper';
import { secondsToHours } from 'date-fns';
import { FC, useMemo } from 'react';
import { BsCupFill } from 'react-icons/bs';
import { useWorkingRoster } from '../providers/WorkingRosterService';
import strings from '../roster.translations';
import { RosterDrawerStatCard } from './RosterDrawerStatCard';

export const RosterBreaks: FC = () => {
  const { workingRoster } = useWorkingRoster();

  if (!workingRoster) throw new Error('Working roster not found');

  const shiftsWithBreak = useMemo(() => {
    return workingRoster.shifts.filter(s => s.breaks.length > 0);
  }, [workingRoster]);

  const totalBreakTime = useMemo(() => {
    return shiftsWithBreak.reduce(
      (shiftTotal, shift) =>
        shiftTotal + shift.breaks.reduce((breakTotal, brek) => breakTotal + (brek.end - brek.start), 0),
      0
    );
  }, [shiftsWithBreak]);

  return (
    <div className="flex flex-row space-x-12 items-center">
      <div className="space-y-2">
        <div className="font-semibold">{strings.drawer.breaks.direction}</div>
        <DragDropButton
          name={strings.drawer.breaks.break}
          Icon={BsCupFill}
          color={itemTypeToColor(ItemTypes.BREAK)}
          textColor="white"
          item={{ type: ItemTypes.BREAK }}
        />
      </div>
      <RosterDrawerStatCard
        label={strings.drawer.breaks.shiftsWithABreak}
        value={strings.drawer.breaks.shiftsWithABreakCount(shiftsWithBreak.length, workingRoster.shifts.length)}
      />
      <RosterDrawerStatCard
        label={strings.drawer.breaks.totalBreakTime}
        value={strings.drawer.breaks.xHours(secondsToHours(totalBreakTime))}
      />
    </div>
  );
};
